import CustomAccordion from "../../../../components/ui/materialui/customAccordion"
import * as yup from 'yup'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Grid2 } from '@mui/material';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import { ImportTablaFormDto } from "../models/importTablaFormDto";
import InputSelect from '../../../../components/inputs/yup/materialui/inputSelect';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import InputFileUpload from "../../../../components/inputs/yup/materialui/inputFileUpload";
import { useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import { getEmisores } from "../../../../services/servicesDominio";
import { Dominios } from "../../../../utils/enums";
import { selectorTransversal } from "../../../../dtos/selector";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";
import { Emisor } from "../../../reportes/generarProcesosMasivos/models/generarArchivoProcesosMasivos";

interface IProps{
    onSubmit: (e: ImportTablaFormDto) => void;
}

export const ImportTableForm = ({onSubmit} : IProps) => {

    const validationSchema: yup.ObjectSchema<ImportTablaFormDto> = yup.object().shape({
        archivo: yup
                .mixed<File>()
                .required("Archivo es requerido")
                .test("fileExists", "Archivo es requerido", value => value instanceof File),
        emisor: yup.string().required("Requerido")
    })

    const {
        register,
        formState: { errors, isDirty },
        handleSubmit,
        reset,
        setValue,
        clearErrors,
        control,
        watch,
    } = useForm<ImportTablaFormDto>({ resolver: yupResolver(validationSchema) })

    const [inputKey, setInputKey] = useState(Date.now()); //KEY PARA INPUTFILE
    const [optionsEmisor, setOptionsEmisor] = useState<selectorTransversal[]>([]);

    const tipoEmisor = async () => {
        const resp: AxiosResponse<ListResponseDto<Emisor>> = await getEmisores();
        if (resp.status === 200) {
            const data: Emisor[] = await resp.data.items;
            const options = data.map((m: any) => ({
                label: m.nombre,
                value: m.rut,
            })); setOptionsEmisor([{ label: "Todos", value: "-1" }, ...options]);
        }
        return;
    }

    useEffect(() => {
        tipoEmisor();
    }, [])

    return (
        <CustomAccordion
            title='Importar tabla de desarrollo'
            expandedDefault
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid2 container spacing={2} sx={{ marginTop: 1 }}>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputSelect
                            name="emisor"
                            label="Emisor"
                            control={control}
                            options={optionsEmisor}
                            error={errors.emisor}
                        />
                    </Grid2>
                    <Grid2 container size={{ xs: 12, lg: 6 }} sx={{ marginTop: 2 }}>
                        <Grid2 size={{ xs: 12, lg:6 }}>
                            <InputFileUpload
                                name="archivo"
                                control={control}
                                label=""
                                accept=".xls,.xlsx"
                                error={errors.archivo}
                                fileKey={inputKey}
                            />
                        </Grid2>
                        <Grid2 container size={{ xs: 12, lg: 6 }} height={"40px"}>
                            <MButton
                                type="button"
                                variant="contained"
                                startIcon={<DeleteIcon />}
                                sx={{ ml: 1 }}
                                onClick={() => {
                                    const input = document.querySelector<HTMLInputElement>('input[type="file"][name="archivo"]');
                                    if (input) input.value = '';
                                    setValue("archivo", {} as File);
                                    setInputKey(Date.now());
                                }}
                            >
                                Limpiar
                            </MButton>
                            <MButton type="submit" variant="contained" color="primary" startIcon={<ArrowCircleUpIcon />}>
                                Subir
                            </MButton>
                        </Grid2>      
                    </Grid2>
                </Grid2>       
            </form>
        </CustomAccordion>
    )
}